import AddCircleIcon from "@mui/icons-material/AddCircle";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { NotificationLog } from "@snubes/snubes-types";
import { useLogListItemProps } from "../helpers/useLogListItemProps";
import { LogListItem } from "../types/LogListItem";
import { LogListItemView } from "./LogListItemView";

export function LogListItemViewForNotification<T extends NotificationLog>(
  props: LogListItem<T>,
) {
  const restProps = useLogListItemProps(props);

  if (props.log.update.id) {
    return (
      <LogListItemView
        {...restProps}
        title="Notification created"
        iconColor="secondary.main"
        iconComponent={AddCircleIcon}
      />
    );
  }

  return (
    <LogListItemView
      {...restProps}
      title="Notification edited"
      iconColor="primary.main"
      iconComponent={ChangeCircleIcon}
    />
  );
}
